import { type Icon } from "@phosphor-icons/react";
import { cn } from "@/lib/utils";
import { useRouter } from "next/router";

interface Props {
  href: string;
  icon: Icon;
  label: string;
  collapsed: boolean;
  active?: boolean;
}

export default function SidebarItem({
  href,
  icon: Icon,
  label,
  collapsed,
  active,
}: Props) {
  const router = useRouter();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    router.push(href);
  };

  return (
    <li>
      <a
        href={href}
        title={collapsed ? label : undefined}
        onClick={handleClick}
        className={cn(
          "group flex items-center gap-3 rounded-xl px-3 py-2 text-sm font-medium transition-all",
          active
            ? "bg-primary-50 text-primary dark:bg-primary-900/30 dark:text-primary-300"
            : "text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 hover:text-primary dark:hover:text-primary-300",
          collapsed && "justify-center px-2",
        )}
      >
        <span
          className={cn(
            "flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-lg transition-colors",
            active
              ? "bg-primary text-white shadow-sm"
              : "bg-gray-100 text-gray-500 dark:bg-gray-800 dark:text-gray-400 group-hover:bg-primary-100 group-hover:text-primary dark:group-hover:bg-primary-900/40 dark:group-hover:text-primary-300",
          )}
        >
          <Icon size={16} />
        </span>

        {!collapsed && (
          <span className="truncate leading-none">{label}</span>
        )}
      </a>
    </li>
  );
}
